import { render, staticRenderFns } from "./AddNewCustomerUserTypePopUp.vue?vue&type=template&id=47cb6962&scoped=true&"
import script from "./AddNewCustomerUserTypePopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewCustomerUserTypePopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCustomerUserTypePopUp.vue?vue&type=style&index=0&id=47cb6962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb6962",
  null
  
)

export default component.exports